import React from 'react';
import styled from 'styled-components';

import { breakpoints, colors } from '../../../constants';

const Image = styled.img`
    width: 100%;
    height: 300px;
    object-fit: cover;
    object-position: top;
`;

interface IProps {
    bgColor: string;
    className?: string;
    imageUrl: string;
}

const BaseInfoSection: React.FC<IProps> = ({
    children,
    className,
    imageUrl,
    bgColor,
}) => (
    <div className={className}>
        <Image src={imageUrl} />
        <div>{children}</div>
    </div>
);

export const InfoSection = styled(BaseInfoSection)`
    background-color: ${({ bgColor }) => bgColor};
    color: ${colors.white};

    > div {
        padding: 30px;

        @media (${breakpoints.smallMin}) {
            padding: 40px;
        }
    }
`;
